import React from 'react';

const NoLinkedEntitiesMessage = () => (
    <div className="no-entities-message-card">
        <h3 className="login_title">You currently have no linked entities!</h3>
        <p>Please ensure that you are listed as authorised person on your company resolution and
            / or have been delegated the required access rights.</p>
    </div>
);
export default NoLinkedEntitiesMessage;